import React, { useEffect, useMemo, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import SwitchPanel from './SwitchPanel';
import TopPanel from './TopPanel';
import { RootStore } from '@/models';

interface ModelState {
  RTCInstance?: RootStore['rtc'];
  simultaneous?: RootStore['simultaneousInterpretation'];
  meeting?: RootStore['meeting'];
  members?: RootStore['members'];
}

interface Props extends ModelState {}

export enum SWITCH_CHANNEL_STEP {
  SWITCH = 'switch',
  TOP = 'top',
}

const SwitchChannel: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    meeting: store.meeting,
    simultaneous: store.simultaneousInterpretation,
    members: store.members,
  };
})(
  observer((props) => {
    const { simultaneous, meeting, members } = props;
    const { info } = meeting || {};
    const { meetingId, channelId } = info || {};
    const { allChannels, currentChannelItem, mainChannelVolume } = simultaneous || {};
    const [currentStep, setCurrentStep] = useState(SWITCH_CHANNEL_STEP.TOP);

    useEffect(() => {
      // 服务端说这个参数必填
      if (channelId) {
        // TODO：getChannels解构使用的话 this就变成null 所以以对象的形式调用
        simultaneous?.getChannels({
          meetingId: `${meetingId}`,
          channelId: `${channelId}`,
        });
      }
    }, [meetingId, channelId]);

    return currentStep === SWITCH_CHANNEL_STEP.TOP ? (
      <TopPanel next={() => setCurrentStep(SWITCH_CHANNEL_STEP.SWITCH)} />
    ) : (
      <SwitchPanel back={() => setCurrentStep(SWITCH_CHANNEL_STEP.TOP)} />
    );
  })
);
export default SwitchChannel;
